import { iterateNested } from "./json"
import { maybeCastValueToString, maybeCastEmptyObjectToEmptyString } from "./cast"

/**
 * Converts a json object to FormData
 * 
 * @param {Object}   json 
 * @param {Function} valueFormatter
 * @returns {FormData}
 */
export const toFormData = (json, valueFormatter) => {
    const formData = new FormData()

    iterateNested(
        json,
        (key, value) => formData.append(
            key,
            valueFormatter instanceof Function
                ? valueFormatter(value)
                : maybeCastEmptyObjectToEmptyString(maybeCastValueToString(value))
        ),
        true
    )

    return formData
}